import { type Store } from '@fiverr-private/store_builder_types';
import { getContext } from '@fiverr-private/fiverr_context';

export const calcChosenNicheId = ({ storeData }: { storeData: Store }) => {
    if (storeData.niche?.id) {
        return Number(storeData.niche.id);
    }

    const { queryParameters } = getContext();

    return Number(queryParameters?.niche);
};
